
import MidEmailOTP from '../../middleware/Authentication/MidEmailOTP';
import { Logo, ToastContainer, overlayStyle, loaderStyle, Link } from '../../common/common'
import useNavigation from '../../common/useNavigation';
const OTP = () => {
    const { users, otp, activeOtpIndex, handleOnKeyDown, handleOnChange, inputRef, handlesubmit, isLoading, timer, isResendDisabled, resendOTP } = MidEmailOTP();
    const { navigateRegisteration, navigatePrivacyPolicy } = useNavigation();

    // CheckAuth();
    if (Array.isArray(users) && users.length > 0) {
        var Email = users[0]['Email'];
    }

    return (
        <div className="bg-white w-full h-screen overflow-y-auto overflow-x-hidden">
            <div>
                <div className=' text-center justify-center flex'>
                    <img src={Logo} width={220} height={70} alt='Logo' />
                </div>
                <div className=' max-w-[360px] w-full bg-white my-0 mx-auto p-7 ' style={{ boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px' }}>
                    <form className="form" >
                        {/* <div className=" align-middle items-center justify-start text-center mt-2">
                            <p className="text-xl m-0 font-medium break-all text-black">
                                <span> Join Over 5 Thousand</span>
                            </p>
                        </div>
                        <div>
                            <p className=" text-[#121A30] text-center mt-2 font-semibold ">
                                Organizations From Around The Globe
                            </p>
                        </div> */}
                        <h1 className="text-xl mt-12 text-center break-all text-black  font-bold">
                            Have You Received <br /> Verification code ?
                        </h1>
                        <p className=" text-black font-semibold text-center my-4 text-sm px-8">

                            Please Enter The Verification Code <br />
                            We Sent To Your Email Address {Email}
                        </p>
                        <div className=" justify-between mx-10 mt-6 my-2">
                            <div className=" flex justify-center items-center space-x-2">
                                {otp.map((_, index) => {
                                    return (
                                        <input
                                            key={index}
                                            ref={index === activeOtpIndex ? inputRef : null}
                                            type="number"
                                            className="spinButtonNone w-12 h-12 border-2 rounded bg-transparent outline-none text-center font-semibold text-xl border-gray-400 focus:border-gray-700 focus:text-gray-700 text-gray-400 transition"
                                            onChange={handleOnChange}
                                            onKeyDown={(e) => handleOnKeyDown(e, index)}
                                            value={otp[index]}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                        <p className=" text-black font-semibold text-center  text-sm px-8"> OTP will expire in: {timer} seconds </p>
                        {/* <Midbutton buttonName="Verify OTP" onClick={() => redfn()} /> */}
                        <button type="button"
                            onClick={handlesubmit}
                            className="relative group m-auto px-12 h-14 text-center rounded-full flex flex-row items-center bg-button-color  hover:bg-button-color"
                        >
                            <span className="relative text-md text-center  text-black font-semibold">
                                Verify OTP
                            </span>
                            <div className="flex items-center h-12 w-12 rounded-3xl bg-button-color absolute right-[-20px] z-20 drop-shadow-3xl ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 stroke-black translate-x-3 transition duration-300 group-hover:translate-x-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                            </div>
                        </button>
                        <div className='text-center my-3'>
                            <button type="button" className='p-2 rounded-md' onClick={resendOTP} disabled={isResendDisabled} style={{ backgroundColor: isResendDisabled ? 'gray' : 'green', color: 'white' }}>
                                {isResendDisabled ? null : 'Resend OTP'}
                            </button>
                        </div>
                    </form>

                    <div className="m-2 border-b-[1px] border-solid border-[#e5e5e5] h-1"></div>
                    <div className="text-center  mx-0 font-semibold ">
                        <p className="py-2 text-sm ">

                            Don't Have an Account?
                            <span
                                className="text-blue-500 cursor-pointer"
                                onClick={navigateRegisteration}
                            >
                                Register Now
                            </span>
                        </p>
                    </div>
                    <div className=" mx-0 text-center mt-2 text-xs text-[#777575] ">
                        <p className=" font-sm font-semibold">
                            This site is protected by reCAPTCHA and the
                            <span
                                className="text-xs text-blue-500 cursor-pointer"
                                onClick={navigatePrivacyPolicy}
                            >

                                Google Privacy Policy
                            </span>
                            and
                            <span
                                className="text-xs text-blue-500 cursor-pointer"
                                onClick={() => { }}
                            >
                                Terms of Service apply.
                            </span>
                        </p>

                    </div>
                </div>

                <footer className='max-w-[1200px]  text-center mt-16 mx-auto  '>

                    <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 xl:grid-cols-7 space-x-2 my-2">
                        <div>
                            <Link to="/features" className="hover:text-blue-600 transition-colors">
                                Features
                            </Link>
                        </div>
                        <div>
                            <Link to="/pricing" className="hover:text-blue-600 transition-colors">
                                Price
                            </Link>
                        </div>
                        <div>
                            <Link to="/application" className="hover:text-blue-600 transition-colors">
                                Application
                            </Link>
                        </div>
                        <div>
                            <Link to="/blog" className="hover:text-blue-600 transition-colors">
                                Blogs
                            </Link>
                        </div>
                        <div>
                            <Link to="/about" className="hover:text-blue-600 transition-colors">
                                About
                            </Link>
                        </div>
                        <div>
                            <Link to="/help" className="hover:text-blue-600 transition-colors">
                                Help
                            </Link>
                        </div>
                        <div>
                            <Link to="/documentation" className="hover:text-blue-600 transition-colors">
                                Documentation
                            </Link>
                        </div>
                    </div>
                    <p className=' text-slate-400 '>&copy; Copyright. All rights Reserved {(new Date().getFullYear())} </p>
                </footer>
            </div>
            <ToastContainer />
            {isLoading && (
                <div style={overlayStyle}>
                    <div style={loaderStyle}>Loading...</div>
                </div>
            )}

        </div>
    )
}

export default OTP